define("SageDotCom/Components/IntacctResourceCentre/IntacctResourceRelated", [
    "jquery",
    "text!SageDotCom/Components/Templates/IntacctResourceCard.html",
    "SageDotCom/Utility/sageMatchHeight"
], function ($, _cardTemplate, SageMatchHeight, mh, eventManager, slick) {

    function IntacctResourcesCollection(scope, resourceData, desktopMinimum, desktopMaximum, mobileMaximum) {
        Object.defineProperty(this, "scope", { enumerable: true, value: scope, writable: !1 });
        Object.defineProperty(this, "$scope", { enumerable: !0, value: $(scope) });

        const relatedDiv = this.$scope.find(".related-intacct-resources-listing");
        const resourceContainer = relatedDiv.find(".intacct-resources");
        const isMobile = resourceContainer.hasClass("is-mobile");
        const shouldShow = isMobile ? resourceData.length > 0 : resourceData.length >= desktopMinimum;

        if (!shouldShow) {
            relatedDiv.remove();
        } else {
            const numberToShow = isMobile ? mobileMaximum : desktopMaximum;
            const relatedTemplate = _.template(_cardTemplate);
            let html = "";
            for (let i = 0; i < numberToShow && i < resourceData.length; i++) {
                html += relatedTemplate(resourceData[i]);
            }

            resourceContainer.html(html);

            scope.addEventListener('lazy-load-evt', this._setSlider());
        }
    }

    IntacctResourcesCollection.prototype._setSlider = function () {
        var self = this;

        new Promise(function(resolve, reject) {
            const settings = {
                draggable: true,
                dots: true,
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 3,
                centerMode: false,
                touchThreshold: 10,
                mobileFirst: false,
                responsive: [
                    {
                        breakpoint: 1440,
                        settings: {
                            slidesToShow: 2.75,
                            slidesToScroll: 2,
                            centerMode: false,
                        }
                    },
                    {
                        breakpoint: 1080,
                        settings: {
                            slidesToShow: 1.6,
                            slidesToScroll: 2,
                            centerMode: false
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1.138,
                            slidesToScroll: 1,
                            centerMode: false
                        }
                    }
                ]
            };

            const $slick = $(".intacct-resources", self.$scope);
            
            // fix stripe
            $('.intacct-resources').closest('.score-stripe').addClass('overflow-hidden position-relative');

            $slick.slick(settings);

            self.$scope.on("init setPosition", function () {
                SageMatchHeight.prototype.applyBinding($(".intacct-resources-listing .slick-slide .flex-item .intacct-body"), true);
            });
            resolve();
        });
    };

    IntacctResourcesCollection.init = function (args) {
        return new IntacctResourcesCollection(args.scope, args.data, args.desktopMinimum, args.desktopMaximum, args.mobileMaximum);
    };

    return IntacctResourcesCollection;
});
define("SageDotCom/Components/Content/IntacctResourcesCentre/IntacctResourceRelated", function(){});

